module.exports = __webpack_public_path__ + "resources/icon-letter-gift-qbi.e1852fcde82e5ed4.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/img/icon-letter-gift-qbi.png
// module id = 834
// module chunks = 0 1